<!--
出荷量一覧表示画面
-->

<template>
  <div>
    <div class="ml-2 mt-12 text-h5" justify="center">{{ title }}</div>
    <div class="ml-2 text-h6" justify="center">{{ userName }}</div>
    <template>
      <v-row class="ma-0" align="start" justify="center"
             v-if="this.$store.getters.userGroupIds.includes('root')">
        <v-col cols="auto" class="ma-0 pd-0 mt-2">生産者：</v-col>
        <v-col cols="auto" class="ma-0" style="width: 340px">
          <v-autocomplete
              class="mx-4"
              outlined
              dense
              hide-details
              color="#0ddbc7"
              v-model="selectProducerName"
              :items="dispProducerItems"
              @input="onSelectProducer"
              placeholder="生産者を選択してください"
              no-data-text="該当する生産者はいません。"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="ma-0" align="start" justify="center">
        <v-col cols="auto" class="ma-0 pd-0 mt-2">表示年：</v-col>
        <v-col cols="auto" class="ma-0" style="width: 340px">
          <v-select
              class="mx-4"
              outlined
              dense
              hide-details
              v-model="dispYear"
              :items="selectDispYears"
              @input="onInputYear"
          ></v-select>
        </v-col>
      </v-row>
    </template>
    <v-data-table
        locale="jp"
        :height="tableHeight"
        mobile-breakpoint="0"
        class="shipmentTable"
        :headers="tableHeaders"
        :items="itemListFiltered"
        item-key="id"
        :fixed-header="true"
        hide-default-footer
        :items-per-page="2000"
        :single-select="false"
        no-results-text="検索条件に合うデータがありません"
        no-data-text="データがありません"
    >
      <!-- テーブルのコンテンツの定義 -->
      <template v-slot:[`item.shipments`]="{ item }">
        <span class="text-truncate text-none blue--text">{{ item.shipments }}</span>
      </template>
      <template v-slot:[`item.totalYear`]="{ item }">
        <span class="text-truncate text-none blue--text">{{ item.totalYear }}</span>
      </template>
    </v-data-table>
    <!-- 表下部の表示件数フィールド -->
    <template>
      <v-row class="ma-0" align="start" justify="center">
        <v-col cols="auto" class="mt-1">
          表示件数：
        </v-col>
        <v-col cols="auto" style="width: 150px;">
          <v-select
              class="mx-4"
              outlined
              dense
              hide-details
              style="margin-top: -6px"
              v-model="itemsPerPage"
              :items="numRowsItems"
              @input="updateTableHeight"
          ></v-select>
        </v-col>
        <v-row class="ma-0" align="start" justify="center">
          <v-col cols="3" class="ma-0 pd-0 d-flex justify-center">
            <v-btn type="button" aria-label="Next page" class="v-pagination__navigation" @click="shiftTable(-1)">
              <v-icon aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-left theme--left"></v-icon>
            </v-btn>
          </v-col>
          <v-col cols="4" class="ma-0 pd-0">
            <v-btn type="button" aria-label="Next page" class="v-pagination__navigation" @click="shiftTable(1)">
              <v-icon aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-right theme--right"></v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-row>
    </template>
  </div>
</template>

<script>

import Api from "@/logic/api/api";
import valueMapper from "@/logic/common/value-mapper";
import AlertBuilder from "@/logic/common/alert-contents";
export default {
  computed: {
    itemListFiltered() {
      return this.itemList.map((item) => {
        const shipment = item.shipment.slice(this.startMonthIndex, this.endMonthIndex + 1);
        return {
          ...item,
          shipment,
        };
      });
    },
    getMonthHeader() {
        let summaryYear = this.dispYear.slice(0, 4);
        let thisYear = summaryYear - 2018;
        let nextYear = thisYear + 1;
        return [
          "R" + thisYear + " 7月",
          "R" + thisYear + " 8月",
          "R" + thisYear + " 9月",
          "R" + thisYear + " 10月",
          "R" + thisYear + " 11月",
          "R" + thisYear + " 12月",
          "R" + nextYear + " 1月",
          "R" + nextYear + " 2月",
          "R" + nextYear + " 3月",
          "R" + nextYear + " 4月",
          "R" + nextYear + " 5月",
          "R" + nextYear + " 6月",
        ];
    },
  },
  data() {
    // 1ページあたりの表示件数リスト
    const numRowsItems = [10, 25, 50, 100];
    this.data_length = 0;
    this.dispProducerItems = [];
    this.selectFromMenuFlag = false
    // URLからuidを取得
    if (this.$route.params.name) {
      // ユーザー名(指定ユーザー)
      this.userName = this.$route.params.name;
      this.selectProducerName = this.$route.params.name;
    } else {
      this.userName = "";
      this.selectProducerName = ["生産者を選択してください"];
      this.selectFromMenuFlag = true
      this.itemList = [];
    }
    if (this.$route.params.uid) {
      // uid(指定ユーザー)
      this.uid = this.$route.params.uid;
      this.selectUid = this.$route.params.uid;
    } else {
      this.uid = [];
      this.selectUid = [];
      this.selectFromMenuFlag = true
      this.itemList = [];
    }
    // 表示月オフセット
    this.disp_offset = 3;

    // ヘッダー文言
    this.headerText = [];
    // 表示年リスト
    this.selectDispYears = [];

    // 表示年リスト作成(現在からシステム基準年(2021年)までの西暦と和暦を詰める)
    var today = new Date();
    var nowYear = today.getFullYear();
    if (today.getMonth() + 1 <= 6) {
      nowYear -= 1;
    }
    // 対象年度取得
    for (var i = 0; i <= nowYear - 2021; i++) {
      var nowYearJP = "(令和" + (nowYear - i - 2018) + ")";
      this.selectDispYears[i] = nowYear - i + nowYearJP + "年";
    }

    // 表示年
    this.getDispYear = this.selectDispYears[0];
    this.selectGroupId = null

    this.title = "";
    return {
      pageHeight: '',
      tableHeight: '',
      // ページあたりに表示する件数
      itemsPerPage: 10,
      // ユーザーリスト設定
      dispProducerItems: this.dispProducerItems,
      // 件数リスト
      numRowsItems: numRowsItems,
      dataLength: this.data_length,
      itemList: [],
      errors: [],
      startMonthIndex: 0,
      endMonthIndex: 2,
      tableHeaders: [],
      // 表示年
      dispYear: this.getDispYear,
      // タイトル
      title: "出荷先ごとの出荷量一覧",
      // 選択中のユーザー情報
      selectGroupId: [],
    };
  },
  beforeMount() {
    if(!this.selectFromMenuFlag){
      this.getShipmentData(this.selectUid)
    }
    this.createTableHeaders();
  },
  watch:  {
    dispYear: {
      handler: function (after, before) {
        console.log(before);
        console.log(after);
        this.createTableHeaders();
      },
    }
  },
  methods: {
    async getUserList() {
      this.$store.commit("setWaiting", true)
      try {
        Api.call("/haccp/shipment/get/user", {})
            .then((result) => {
              this.$store.commit("setWaiting", false);
              // デバイスが存在する場合はデバイス一覧を作成
              if (result) {
                for(const user of result.userList){
                  this.dispProducerItems.push(user.displayName);
                }
              }
            })
            .catch((error) => {
              this.$store.commit("setWaiting", false);
              const message = valueMapper
                  .map({
                    401: AlertBuilder.error("ユーザーの取得に失敗しました"),
                  })
                  .getOrElse(error.status, AlertBuilder.invalid());
              if (message.isInvalid) {
                Api.resolve(error);
              } else {
                this.showMessage(message);
              }
            })        
      } finally {
        this.$store.commit("setWaiting", false)
      }
    },
    createTableHeaders() {
      this.tableHeaders = [
        {
          text: "出荷物",
          align: "start",
          value: "shipments",
          class: "grey darken-1 white--text",
          width: "50px",
        },
        {
          text: "出荷先",
          align: "center",
          value: "ShippingDest",
          class: "grey darken-1 white--text",
          width: "50px",
        },
      ];

      //let month = ["7月", "8月", "9月", "10月", "11月", "12月", "1月", "2月", "3月", "4月", "5月", "6月"];
      let month = this.getMonthHeader;

      for (let i = this.startMonthIndex; i <= this.endMonthIndex; i++) {
        this.tableHeaders.push({
          text: month[i],
          align: "center",
          value: `shipment[${i - this.startMonthIndex}]`,
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        });
      }

      this.tableHeaders.push({
        text: "年計",
        align: "center",
        value: "totalYear",
        class: "grey darken-1 white--text",
        width: "50px",
      });
    },


    shiftTable(direction) {
      // テーブルを1ヶ月分ずらすロジックを実装する
      if (direction === -1) {
        // 左にずらす処理
        if (this.startMonthIndex > 0) {
          this.startMonthIndex--;
          this.endMonthIndex--;
          this.createTableHeaders();
        }
      } else if (direction === 1) {
        // 右にずらす処理
        if (this.endMonthIndex < 11) {
          this.startMonthIndex++;
          this.endMonthIndex++;
          this.createTableHeaders();
        }
      }
    },

    /**
     * 生産者UIDおよび表示グラフを更新する
     */
    onSelectProducer() {
      // if (this.selectFromMenuFlag) { this.dispProducerItems.shift() }  ← 削除
      this.selectFromMenuFlag = false
      this.userName = this.selectProducerName;
      const haccpUserList = this.$store.getters.haccpUserList;
      const index = haccpUserList.map(el => el.userName).indexOf(this.selectProducerName);
      this.selectUid = haccpUserList[index].uid;
      this.clearMessage();
      this.getShipmentData(this.selectUid);
    },

    /**
     * 表示年が選択されたらデータ再取得
     */
    onInputYear() {
      if(!this.selectFromMenuFlag){
        this.getShipmentData(this.selectUid);
      }
    },

    /**
     * 表示年が選択されたらデータ再取得
     */
    async getShipmentData(selectUid) {
      var summaryYear = 0;
      summaryYear = this.dispYear.slice(0, 4);
      console.log(summaryYear);
      let vm = this
      let postData = {
        uid: selectUid,
        summary_type: "SHIPPING",
        summary_year: summaryYear,
      };
      this.$store.commit("setWaiting", true);

      // うみログデバイス一覧情報を取得
      Api.call("/haccp/record/summary/shipment", postData)
          .then((result) => {
            vm.$store.commit("setWaiting", false);
            // デバイスが存在する場合はデバイス一覧を作成
            if (result) {
              console.log(result);
              this.dataLength = result.item_lists.length;
              this.setData(result, this.dataLength);
            }
          })
          .catch((error) => {
            vm.$store.commit("setWaiting", false);
            const message = valueMapper
                .map({
                  401: AlertBuilder.error("データの更新に失敗しました"),
                })
                .getOrElse(error.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(error);
            } else {
              vm.showMessage(message);
            }
          })
    },

    setData(result, dataLength) {
      this.itemList = result.item_lists;
      this.data_length = dataLength;
      this.updateTableHeight()
    },

    updateTableHeight() {
      if (this.itemsPerPage === 10 && this.data_length >= 10) {
        this.tableHeight = '528px';
      } else if (this.itemsPerPage === 25 && this.data_length >= 25) {
        this.tableHeight = '1455px';
      } else if (this.itemsPerPage === 50 && this.data_length >= 50) {
        this.tableHeight = '2910px';
      } else if (this.itemsPerPage === 100 && this.data_length >= 100) {
        this.tableHeight = '5280px';
      } else {
        this.tableHeight = ''; // テーブルの高さをリセット
      }
    },
    /**
     * メッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.getUserList();
  },
};
</script>

<style>


.shipmentTable {
  border-bottom: solid 2px #E3E3E3;
  white-space: nowrap;
}

.shipmentTable th {
  font-size: 15px !important;
}

.shipmentTable td {
  font-size: 15px !important;
  border-right: solid 2px #F3F3F3;
}


.shipmentTable div.v-data-table__wrapper {
  overflow-x: auto;
  overflow-y: auto;
}


th {
  background-color: #757575 !important;
}

th.sortable .v-data-table-header__icon {
  color: rgb(255, 255, 255, 0.15) !important;
}

th.sortable.active .v-data-table-header__icon {
  color: rgb(255, 255, 255, 1) !important;
}
</style>
